export const FACEBOOK_API_VERSION = 'v20.0'
